import React from 'react'
import PropTypes from 'prop-types'
import { pathOr } from 'ramda'

import PopUp from '../../../popUp'
import settings from '../../../firstStep/helpers/drupalSettings'
import Ico from '../../../../../assets/images/svg/BRANDING_LOGO_red.svg'

import './styles.scss'

const { text, button, link } = pathOr({
  text: 'Vos trois appartements sont bien sélectionnés, voulez vous :',
  button: 'Confirmez votre réservation',
  link: 'Modifier votre réservation',
}, ['multipleConfirmation'], settings)

const MultipleConfirmation = ({ data }) => (
  <PopUp>
    <div className="multiple-confirmation-popup">
      <img src={Ico} alt="Adagio" className="multiple-confirmation-popup__ico" />
      <p className="multiple-confirmation-popup__text">
        {text}
      </p>
      <button
        type="button"
        className="multiple-confirmation-popup__btn"
        onClick={data.bookFunction}
      >
        {button}
      </button>
      <a
        href="#close"
        onClick={data.redirectFunc}
        className="multiple-confirmation-popup__link"
      >
        {link}
      </a>
    </div>
  </PopUp>
)

MultipleConfirmation.propTypes = {
  data: PropTypes.objectOf(PropTypes.func).isRequired,
}

export default MultipleConfirmation
